export default "__VITE_ASSET__CyY$0R2Q__"